<div fxLayout="column" class="admin-container">
    <div fxLayout="row" >
        <div fxLayout="row" fxLayoutGap="15px" style="padding-bottom: 2%" fxFlex="40">
            <img src="assets/back-arrow-icon.svg" [routerLink]="'/admin'" style="cursor:pointer">
            <span class="page-title">{{merchantName}}</span>
        </div>
        <div fxLayoutAlign="center end" *ngIf="showNotification">
            <div class="notification" fxLayoutAlign="center end">
                You KYC has been approved
            </div>
        </div>
        <div fxLayoutAlign="center end" *ngIf="showRejectNotification">
            <div class="notification" fxLayoutAlign="center end">
                You KYC has been rejected
            </div>
        </div>
        
    </div>
   
    <div fxLayout="row">
        <mat-tab-group animationDuration="0ms" style="width:100%;" (selectedTabChange)="onTabChanged($event)">
            <mat-tab label="KYC Verification" class="kyc-label">
                <div>
                    <app-admin-kyc-verification  (approveButtonClicked)="changeshowNotification($event)"  (rejectButtonClicked)="rejectNotification($event)" [merchant_id]="merchant_id"></app-admin-kyc-verification>
                </div>
            </mat-tab>
            <mat-tab label="Bot Verification" class="kyc-label">
                <div>
                    <app-admin-bot [merchant_id]="merchant_id" [refresh]="refresh"></app-admin-bot>
                </div>
            </mat-tab>
            <mat-tab label="Template Verification" class="kyc-label">
                <div>
                    <app-admin-template [merchant_id]="merchant_id"></app-admin-template>
                </div>
            </mat-tab>
            <mat-tab label="Mini app Verification" class="kyc-label">
                <div>
                    <app-admin-miniapp [merchant_id]="merchant_id" [refresh]="refresh"></app-admin-miniapp>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>